import { Component, ViewChild } from "@angular/core";
import {
  IonicPage,
  NavParams,
  PopoverController,
  ViewController,
} from "ionic-angular";
import { BehaviorSubject } from "rxjs";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { EntitiesProvider } from "../../providers/entities/entities";
import { TrendExplorerComponent } from "../../components/trend-explorer/trend-explorer.component";

@IonicPage()
@Component({
  selector: "page-trend-explorer-2",
  templateUrl: "trend-explorer-2.html",
})
// tslint:disable-next-line:class-name
export class TrendExplorer_2Page {
  initialData: any;
  tags: Array<any> = [];
  @ViewChild("tx") tx: TrendExplorerComponent;

  addSignalsEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  openPreferencesEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  initialTag: any;
  loading = true;

  constructor(
    public nav: NavParams,
    private starms: StarmsClientProvider,
    private viewCtrl: ViewController,
    public popoverCtrl: PopoverController,
    private entitiesProvider: EntitiesProvider
  ) {
    console.log("trend", nav);
    this.loading = true;
    // Pass signal data to the trend explorer core component
    this.initialData = nav.data["initialData"];
    this.initialTag = nav.data["initialTagChanges"];
  }

  ionViewDidLoad(): void {
    this.loading = true;
    this.starms
      .get([
        "signals/signaltags/trains",
        this.entitiesProvider.currentEntity.getId(),
      ])
      .subscribe((tagsData) => {
        this.tags = tagsData.map((tag) => {
          tag.UI = {
            opened: false,
            ready: false,
          };
          return tag;
        });
        // this.loading = false;
      });
  }
  loadedData(event) {
    this.loading = false;
  }
  showSignals(): void {
    this.addSignalsEvent.next(true);
  }

  showPreferences(): void {
    this.openPreferencesEvent.next(true);
  }

  dismiss(): void {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/trend-explorer-2/trend-explorer-2.ts